import React from 'react';
import './About.css';

// ✅ Premium Icons
import {
  FaUserTie,
  FaLaptopCode,
  FaHandshake,
  FaChartLine,
  FaBullseye,
  FaUserGraduate,
  FaRocket,
  FaArrowUp,
  FaAtom, // For the "VERSE" galaxy icon
  FaBriefcase,
  FaPercent
} from 'react-icons/fa';

const About = () => {
  return (
    <section className="about-section" id="about">
      {/* 🌌 Background Effects */}
      <div className="about-bg-elements">
        <div className="glow-orb orb-1"></div>
        <div className="glow-orb orb-2"></div>
        <div className="stars-overlay"></div>
      </div>

      <div className="about-container">

        {/* ==================== TITLE & SUBTITLE ==================== */}
        <div className="about-header slide-up">
          <h2 className="about-title">What is TrekVerse?</h2>
          <p className="about-description">
            TrekVerse is a next-generation EdTech company designed to transform students into industry-ready professionals.
            We bridge the gap between Campus and Corporate with practical learning and real-world exposure.
          </p>
        </div>

        {/* ==================== TRUST & AUTHORITY (STATS) ==================== */}
        <div className="stats-grid slide-up delay-1">
          <div className="stat-card">
            <div className="stat-icon"><FaUserGraduate /></div>
            <h3 className="stat-number">3500+</h3>
            <p className="stat-label">Students Trained</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon"><FaBriefcase /></div>
            <h3 className="stat-number">100+</h3>
            <p className="stat-label">Placements Secured</p>
          </div>
          <div className="stat-card">
            <div className="stat-icon"><FaPercent /></div>
            <h3 className="stat-number">95%</h3>
            <p className="stat-label">Success Rate</p>
          </div>
        </div>

        <div className="about-grid">
          {/* ==================== LEFT: TREK + VERSE CARDS ==================== */}
          <div className="meaning-section slide-up delay-2">
            <h3 className="section-subtitle">The Meaning Behind The Name</h3>

            <div className="glass-card trek-card">
              <div className="card-icon-wrapper pulse">
                <FaChartLine className="card-icon" />
              </div>
              <div>
                <h4 className="card-title">TREK</h4>
                <p className="card-text">Your growth journey. Step-by-step skill and career development pushing you upward.</p>
              </div>
            </div>

            <div className="glass-card verse-card">
              <div className="card-icon-wrapper spin-slow">
                <FaAtom className="card-icon" />
              </div>
              <div>
                <h4 className="card-title">VERSE</h4>
                <p className="card-text">Your universe of opportunities. A limitless learning ecosystem waiting to be explored.</p>
              </div>
            </div>
          </div>

          {/* ==================== RIGHT: VISION LIST ==================== */}
          <div className="vision-section slide-up delay-3">
            <h3 className="section-subtitle">Our Vision</h3>
            <div className="glass-card vision-card">
              <ul className="features-list">
                <li><FaUserTie className="list-icon" /> <span>Transform students into industry-ready professionals</span></li>
                <li><FaLaptopCode className="list-icon" /> <span>Practical learning with real-world projects</span></li>
                <li><FaHandshake className="list-icon" /> <span>Direct corporate exposure and mentorship</span></li>
                <li><FaChartLine className="list-icon" /> <span>Performance-based growth tracking</span></li>
                <li><FaBullseye className="list-icon" /> <span>Seamless Campus to Corporate transition</span></li>
              </ul>
            </div>
          </div>
        </div>

        {/* ==================== CALL TO ACTION (CTA) ==================== */}
        <div className="about-cta slide-up delay-4">
          <h2>Start Your Journey with TREKVERSE</h2>
          <p>Join thousands of professionals advancing their careers today.</p>
          <div className="cta-buttons">
            <button className="btn-primary" onClick={() => {
              const element = document.querySelector('.programs');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}>Apply Now <FaArrowUp className="btn-arrow" /></button>
            <button className="btn-secondary" onClick={() => {
              const element = document.querySelector('.programs');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}>Explore Programs</button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;